import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { LiveAnnouncerService } from 'src/app/app-common/services/live-announcer.service';
import {
  StorageFile,
  StorageFilesDetails,
  StorageSelectorFilter,
  StorageSelectorType,
  StorageUtilsService,
} from '../../services/storage-utils.service';
import { StorageService } from '../../services/storage.service';
import { ListItem, ListOperation } from 'src/app/components/scrolling-list';
import { StorageApiSearch } from 'src/app/api/services/api-utils.service';

@Component({
  selector: 'storage-list-view',
  templateUrl: './storage-list-view.component.html',
  styleUrls: ['./storage-list-view.component.scss'],
  standalone: false,
})
export class StorageListViewComponent implements AfterViewInit {
  @Input() files: ListItem<StorageFile>[];
  @Input() folderPath: string = '';
  @Input() filesDetails: StorageFilesDetails;
  @Input() fileListVisible: boolean;
  @Input() search: StorageApiSearch;
  @Input() isAllSelected: boolean;
  @Input() isEmpty: boolean;
  @Input() listOperations: ListOperation<StorageFile>[] = [];
  @Input({ required: true }) selectorType: StorageSelectorType;
  @Input({ required: true }) selectorFilter: StorageSelectorFilter;
  @Input({ required: true }) storageFull: boolean;
  @Output() selectAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() fileClick: EventEmitter<ListItem<StorageFile>> = new EventEmitter<
    ListItem<StorageFile>
  >();
  @Output() fileSelect: EventEmitter<ListItem<StorageFile>> = new EventEmitter<
    ListItem<StorageFile>
  >();
  @Output() uploadFiles: EventEmitter<void> = new EventEmitter<void>();
  @Output() operationClick: EventEmitter<{
    file: ListItem<StorageFile>;
    operationName: string;
  }> = new EventEmitter<{
    file: ListItem<StorageFile>;
    operationName: string;
  }>();

  protected get isTrashFolder(): boolean {
    return this.storageUtilsService.isTrashFolder(this.folderPath);
  }

  constructor(
    public storageUtilsService: StorageUtilsService,
    public storageService: StorageService,
    private liveAnnouncerService: LiveAnnouncerService,
  ) {}

  ngAfterViewInit(): void {
    const sortBy = this.search?.sortBy ?? 'name';
    const reverse = !!this.search?.reverse;
    const fieldLabel = this.labelMap[sortBy] || sortBy;
    this.announceSort(fieldLabel, reverse ? 'descending' : 'ascending');
  }

  changeSort(field: string) {
    if (this.search.sortBy === field) {
      this.search.reverse = !this.search.reverse;
    } else {
      this.search.sortBy = field;
    }
    this.announceSort(
      this.labelMap[field] || field,
      this.search.reverse ? 'descending' : 'ascending',
    );
  }

  announceSort(fieldLabel: string, direction: 'ascending' | 'descending') {
    this.liveAnnouncerService.announce(
      `Table sorted by ${fieldLabel}, ${direction} order`,
    );
  }

  get foldersAndFiles() {
    return [
      ...this.storageUtilsService.filterFolders(
        this.files,
        this.search,
        this.storageFull,
      ),
      ...this.storageUtilsService.filterFiles(
        this.files,
        this.search,
        this.storageFull,
        true,
      ),
    ];
  }

  get labelMap() {
    return {
      name: 'Name',
      extension: 'Type',
      size: 'Size',
      dateModified: 'Modified',
    };
  }
}
